export default [
	"dashboard",
	"stream rating",
	"users",
	"streamers",
	"playlist",
	"channel list",
	"logs",
	"subscribers",
	"regions",
	"admins"
];



// WEBPACK FOOTER //
// ./src/script/optionMenuNotKV.js